import * as PIXI from "pixi.js";
import { filters as NativePixiFilters } from "pixi.js";

import * as PIXIAnimate from "@pixi/animate";
import * as PIXIFilters from "pixi-filters";

export * from "pixi.js";
export * as animate from "@pixi/animate";

export const filters = {
  ...PIXIFilters,
  ...NativePixiFilters,
};

// @ts-ignore => For PIXI debugger
// window.PIXI = PIXI;

// We can't use members of MovieClip, it's not updated with current frame. This getter function workaround that.
Object.defineProperties(PIXIAnimate.MovieClip.prototype, {
  get: {
    value: function (key: string) {
      return this.children.find((child) => child.name === key);
    },
  },
} as PropertyDescriptorMap & ThisType<PIXIAnimate.MovieClip>);
